import { createContext, useState, useMemo, useContext, useCallback } from 'react';

const FallasContext = createContext();

export function FallasProvider(props) {
    const tokenSessionObject = JSON.parse(sessionStorage.getItem('token'));
    const [catego, setCatego] = useState([]);
    const [fallas, setFallas] = useState([]);
    const [fallasBk, setFallasBk] = useState([]);
    const [areas, setAreas] = useState([]);
    const [text, setText] = useState('');
    const [textF, setTextF] = useState('');
    const [openM, setOpenM] = useState(false);
    const [openC, setOpenC] = useState(false);
    const [updateGridF, setUpdateGridF] = useState(false);
    const [updateGridC, setUpdateGridC] = useState(false);
    const [selectedArea, setSelectedArea] = useState('');
    const [selectedCatego, setSelectedCatego] = useState('');
    const [snackbar, setSnackbar] = useState(false);
    const [snackbarText, setSnackbarText] = useState('');

    const getCatego = useCallback(async () => {
        const data = await fetch(`${process.env.REACT_APP_SERVICE_ENDPOINT}/categorias`, {
            method: 'GET',
            headers: {
                authorization: `Bearer ${tokenSessionObject.token}`,
                Accept: 'application/json',
            },
        });
        const categos = await data.json();
        categos.forEach((element) => {
            element.id = element.categoria;
        });

        setCatego(categos);
    }, [tokenSessionObject.token]);

    const getAreasAndFallas = useCallback(async () => {
        const dataAreas = await fetch(`${process.env.REACT_APP_SERVICE_ENDPOINT}/areas`, {
            method: 'GET',
            headers: {
                authorization: `Bearer ${tokenSessionObject.token}`,
                Accept: 'application/json',
            },
        });
        const areasJS = await dataAreas.json();
        setAreas(areasJS);
        const data = await fetch(`${process.env.REACT_APP_SERVICE_ENDPOINT}/fallas`, {
            method: 'GET',
            headers: {
                authorization: `Bearer ${tokenSessionObject.token}`,
                Accept: 'application/json',
            },
        });
        const fallasJS = await data.json();

        fallasJS.forEach((element) => {
            element.id = element.idFalla;
            areasJS.forEach((item) => {
                if (item.area1 === element.area) {
                    element.areaNombre = item.nombre;
                }
            });
        });
        setFallasBk(fallasJS);
        setFallas(fallasJS);
    }, [tokenSessionObject.token]);

    const postFalla = useCallback((data) => {
        fetch(`${process.env.REACT_APP_SERVICE_ENDPOINT}/fallas`, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                authorization: `Bearer ${tokenSessionObject.token}`,
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        }).then(async (response) => {
            const isJson = response.headers.get('content-type')?.includes('application/json');
            const data1 = isJson && (await response.json());
            if (!response.ok) {
                const error = (data1 && data1.message) || response.status;
                return Promise.reject(error);
            } else {
                setOpenM(false);
                setTextF('');
                setSelectedArea('');
                setSelectedCatego('');
                setUpdateGridF(true);
                setSnackbarText('Falla creada correctamente');
                setSnackbar(true);
            }
        });
    }, [tokenSessionObject.token]);

    const postCatego = useCallback((data) => {
        fetch(`${process.env.REACT_APP_SERVICE_ENDPOINT}/categorias/CrearCategoria`, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                authorization: `Bearer ${tokenSessionObject.token}`,
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        }).then(async (response) => {
            const isJson = response.headers.get('content-type')?.includes('application/json');
            const data1 = isJson && (await response.json());
            if (!response.ok) {
                const error = (data1 && data1.message) || response.status;

                return Promise.reject(error);
            } else {
                setText('');
                setUpdateGridC(true);
                setOpenC(false);
                setSnackbarText('Categoría creada correctamente');
                setSnackbar(true);
            }
        });
    }, [tokenSessionObject.token]);

    const handleDataSelect = useCallback((info) => {
        if (info.length !== 0) {
            let filterFalla = [];
            fallasBk.forEach((fal) => {
                info.forEach((inf) => {
                    if (fal.idCategoria === inf) {
                        filterFalla.push(fal);
                    }
                });
            });
            setFallas([]);
            setFallas(filterFalla);
        } else {
            getAreasAndFallas();
        }
    }, [fallasBk, getAreasAndFallas]);

    const createCatego = useCallback((event) => {
        event.preventDefault();
        const data = {
            nombre: text,
            tipo: 1,
        };
        postCatego(data);
    }, [postCatego, text]);

    const createFalla = useCallback((event) => {
        event.preventDefault();

        const arrFallas = [];
        fallasBk.forEach((element) => {
            arrFallas.push(parseInt(element.idFalla));
        });
        const maxFallaId = arrFallas.length > 0 ? Math.max(...arrFallas) : 0;

        const recolectedData = {
            idFalla: maxFallaId + 1,
            area: parseInt(selectedArea),
            idCategoria: parseInt(selectedCatego),
            nombre: textF,
        };

        postFalla(recolectedData);
    }, [fallasBk, postFalla, selectedArea, selectedCatego, textF]);

    const handleOpenM = () => {
        setOpenM(true);
    };

    const handleCloseM = () => {
        setOpenM(false);
    };

    const handleOpenC = () => {
        setOpenC(true);
    };

    const handleCloseC = () => {
        setOpenC(false);
    };

    const fallasValues = useMemo(() => {
        return {
            catego,
            setCatego,
            fallas,
            setFallas,
            areas,
            setAreas,
            postFalla,
            postCatego,
            handleDataSelect,
            text,
            setText,
            textF,
            setTextF,
            openM,
            setOpenM,
            createCatego,
            handleOpenM,
            handleCloseM,
            handleOpenC,
            handleCloseC,
            createFalla,
            selectedArea,
            setSelectedArea,
            selectedCatego,
            setSelectedCatego,
            getCatego,
            getAreasAndFallas,
            fallasBk,
            updateGridF,
            setUpdateGridF,
            updateGridC,
            setUpdateGridC,
            openC,
            snackbar,
            setSnackbar,
            snackbarText,
        };
    }, [catego, fallas, areas, postFalla, postCatego, handleDataSelect, text, textF, openM, createCatego, createFalla, selectedArea, selectedCatego, getCatego, getAreasAndFallas, fallasBk, updateGridF, updateGridC, openC, snackbar, snackbarText]);

    return <FallasContext.Provider value={fallasValues} {...props} />;
}

export function useFallas() {
    const context = useContext(FallasContext);
    if (!context) {
        throw new Error('useFallas debe estar dentro del proveedor FallasContext');
    }
    return context;
}
